/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightLoyaltyAttachment } from "./FlightLoyaltyAttachment";
import {
  FlightLoyaltyAttachmentFromJSON,
  FlightLoyaltyAttachmentFromJSONTyped,
  FlightLoyaltyAttachmentToJSON,
  FlightLoyaltyAttachmentToJSONTyped,
} from "./FlightLoyaltyAttachment";
import type { FlightCheckoutFare } from "./FlightCheckoutFare";
import {
  FlightCheckoutFareFromJSON,
  FlightCheckoutFareFromJSONTyped,
  FlightCheckoutFareToJSON,
  FlightCheckoutFareToJSONTyped,
} from "./FlightCheckoutFare";
import type { FlightCheckoutTimelineEvent } from "./FlightCheckoutTimelineEvent";
import {
  FlightCheckoutTimelineEventFromJSON,
  FlightCheckoutTimelineEventFromJSONTyped,
  FlightCheckoutTimelineEventToJSON,
  FlightCheckoutTimelineEventToJSONTyped,
} from "./FlightCheckoutTimelineEvent";
import type { FlightCheckoutFailure } from "./FlightCheckoutFailure";
import {
  FlightCheckoutFailureFromJSON,
  FlightCheckoutFailureFromJSONTyped,
  FlightCheckoutFailureToJSON,
  FlightCheckoutFailureToJSONTyped,
} from "./FlightCheckoutFailure";
import type { FlightCheckoutAction } from "./FlightCheckoutAction";
import {
  FlightCheckoutActionFromJSON,
  FlightCheckoutActionFromJSONTyped,
  FlightCheckoutActionToJSON,
  FlightCheckoutActionToJSONTyped,
} from "./FlightCheckoutAction";
import type { FlightObservedItinerary } from "./FlightObservedItinerary";
import {
  FlightObservedItineraryFromJSON,
  FlightObservedItineraryFromJSONTyped,
  FlightObservedItineraryToJSON,
  FlightObservedItineraryToJSONTyped,
} from "./FlightObservedItinerary";
import type { FlightPassengerComposition } from "./FlightPassengerComposition";
import {
  FlightPassengerCompositionFromJSON,
  FlightPassengerCompositionFromJSONTyped,
  FlightPassengerCompositionToJSON,
  FlightPassengerCompositionToJSONTyped,
} from "./FlightPassengerComposition";
import type { FlightCheckoutPrice } from "./FlightCheckoutPrice";
import {
  FlightCheckoutPriceFromJSON,
  FlightCheckoutPriceFromJSONTyped,
  FlightCheckoutPriceToJSON,
  FlightCheckoutPriceToJSONTyped,
} from "./FlightCheckoutPrice";

/**
 *
 * @export
 * @interface FlightBookingResponse
 */
export interface FlightBookingResponse {
  /**
   * Independent outcome for checkout-selected seats or bags; never replaces flight ticketing status.
   * @type {string}
   * @memberof FlightBookingResponse
   */
  ancillaryStatus?: FlightBookingResponseAncillaryStatusEnum | null;
  /**
   * Account-free attachment evidence; omitted by older producers.
   * @type {Array<FlightLoyaltyAttachment>}
   * @memberof FlightBookingResponse
   */
  loyaltyAttachments?: Array<FlightLoyaltyAttachment>;
  /**
   * Persisted supplier execution mode; test consumers require an affirmative acknowledgment.
   * @type {boolean}
   * @memberof FlightBookingResponse
   */
  test?: boolean;
  /**
   *
   * @type {number}
   * @memberof FlightBookingResponse
   */
  schemaVersion: FlightBookingResponseSchemaVersionEnum;
  /**
   *
   * @type {string}
   * @memberof FlightBookingResponse
   */
  bookingId: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingResponse
   */
  bookingRequestId: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingResponse
   */
  status: FlightBookingResponseStatusEnum;
  /**
   *
   * @type {string}
   * @memberof FlightBookingResponse
   */
  paymentStatus: FlightBookingResponsePaymentStatusEnum;
  /**
   * Known supplier ticketing deadline; elapsed time does not prove cancellation.
   * @type {Date}
   * @memberof FlightBookingResponse
   */
  ticketingDeadline?: Date | null;
  /**
   * Local processing limit; unresolved bookings require support after this time.
   * @type {Date}
   * @memberof FlightBookingResponse
   */
  processingExpiresAt?: Date | null;
  /**
   *
   * @type {string}
   * @memberof FlightBookingResponse
   */
  ticketingStatus: FlightBookingResponseTicketingStatusEnum;
  /**
   *
   * @type {FlightCheckoutAction}
   * @memberof FlightBookingResponse
   */
  actionRequired: FlightCheckoutAction | null;
  /**
   *
   * @type {string}
   * @memberof FlightBookingResponse
   */
  provider?: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingResponse
   */
  providerOrderId?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightBookingResponse
   */
  pnr: string | null;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof FlightBookingResponse
   */
  airlineLocators?: { [key: string]: string };
  /**
   *
   * @type {Array<string>}
   * @memberof FlightBookingResponse
   */
  ticketDocuments: Array<string>;
  /**
   *
   * @type {FlightObservedItinerary}
   * @memberof FlightBookingResponse
   */
  itinerary?: FlightObservedItinerary | null;
  /**
   *
   * @type {FlightCheckoutFare}
   * @memberof FlightBookingResponse
   */
  fare?: FlightCheckoutFare;
  /**
   *
   * @type {FlightCheckoutPrice}
   * @memberof FlightBookingResponse
   */
  price?: FlightCheckoutPrice;
  /**
   *
   * @type {FlightPassengerComposition}
   * @memberof FlightBookingResponse
   */
  passengers?: FlightPassengerComposition | null;
  /**
   *
   * @type {string}
   * @memberof FlightBookingResponse
   */
  cancellationStatus?: FlightBookingResponseCancellationStatusEnum;
  /**
   *
   * @type {string}
   * @memberof FlightBookingResponse
   */
  refundStatus?: FlightBookingResponseRefundStatusEnum;
  /**
   *
   * @type {FlightCheckoutFailure}
   * @memberof FlightBookingResponse
   */
  failure: FlightCheckoutFailure | null;
  /**
   *
   * @type {Array<FlightCheckoutTimelineEvent>}
   * @memberof FlightBookingResponse
   */
  timeline: Array<FlightCheckoutTimelineEvent>;
  /**
   *
   * @type {Date}
   * @memberof FlightBookingResponse
   */
  updatedAt: Date;
}

/**
 * @export
 */
export const FlightBookingResponseAncillaryStatusEnum = {
  Pending: "pending",
  Processing: "processing",
  Fulfilled: "fulfilled",
  NeedsAttention: "needs_attention",
} as const;
export type FlightBookingResponseAncillaryStatusEnum =
  (typeof FlightBookingResponseAncillaryStatusEnum)[keyof typeof FlightBookingResponseAncillaryStatusEnum];

/**
 * @export
 */
export const FlightBookingResponseSchemaVersionEnum = {
  NUMBER_1: 1,
} as const;
export type FlightBookingResponseSchemaVersionEnum =
  (typeof FlightBookingResponseSchemaVersionEnum)[keyof typeof FlightBookingResponseSchemaVersionEnum];

/**
 * @export
 */
export const FlightBookingResponseStatusEnum = {
  PaymentPending: "payment_pending",
  PaymentAuthorized: "payment_authorized",
  OrderCreating: "order_creating",
  OrderCreated: "order_created",
  TicketingPending: "ticketing_pending",
  Ticketed: "ticketed",
  PartiallyTicketed: "partially_ticketed",
  Failed: "failed",
  NeedsAttention: "needs_attention",
} as const;
export type FlightBookingResponseStatusEnum =
  (typeof FlightBookingResponseStatusEnum)[keyof typeof FlightBookingResponseStatusEnum];

/**
 * @export
 */
export const FlightBookingResponsePaymentStatusEnum = {
  Pending: "pending",
  ActionRequired: "action_required",
  Authorized: "authorized",
  Captured: "captured",
  Failed: "failed",
  NeedsAttention: "needs_attention",
  Submitted: "submitted",
  SupplierPaid: "supplier_paid",
} as const;
export type FlightBookingResponsePaymentStatusEnum =
  (typeof FlightBookingResponsePaymentStatusEnum)[keyof typeof FlightBookingResponsePaymentStatusEnum];

/**
 * @export
 */
export const FlightBookingResponseTicketingStatusEnum = {
  NotStarted: "not_started",
  OrderCreated: "order_created",
  Pending: "pending",
  Ticketed: "ticketed",
  PartiallyTicketed: "partially_ticketed",
  Failed: "failed",
  NeedsAttention: "needs_attention",
} as const;
export type FlightBookingResponseTicketingStatusEnum =
  (typeof FlightBookingResponseTicketingStatusEnum)[keyof typeof FlightBookingResponseTicketingStatusEnum];

/**
 * @export
 */
export const FlightBookingResponseCancellationStatusEnum = {
  NotRequested: "not_requested",
  CancellationQuoted: "cancellation_quoted",
  CancellationPending: "cancellation_pending",
  Cancelled: "cancelled",
  Failed: "failed",
  NeedsAttention: "needs_attention",
} as const;
export type FlightBookingResponseCancellationStatusEnum =
  (typeof FlightBookingResponseCancellationStatusEnum)[keyof typeof FlightBookingResponseCancellationStatusEnum];

/**
 * @export
 */
export const FlightBookingResponseRefundStatusEnum = {
  NotRequested: "not_requested",
  RefundPending: "refund_pending",
  PartiallyRefunded: "partially_refunded",
  Refunded: "refunded",
  Failed: "failed",
  NeedsAttention: "needs_attention",
} as const;
export type FlightBookingResponseRefundStatusEnum =
  (typeof FlightBookingResponseRefundStatusEnum)[keyof typeof FlightBookingResponseRefundStatusEnum];

/**
 * Check if a given object implements the FlightBookingResponse interface.
 */
export function instanceOfFlightBookingResponse(
  value: object
): value is FlightBookingResponse {
  if (!("schemaVersion" in value) || value["schemaVersion"] === undefined)
    return false;
  if (!("bookingId" in value) || value["bookingId"] === undefined) return false;
  if (!("bookingRequestId" in value) || value["bookingRequestId"] === undefined)
    return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("paymentStatus" in value) || value["paymentStatus"] === undefined)
    return false;
  if (!("ticketingStatus" in value) || value["ticketingStatus"] === undefined)
    return false;
  if (!("actionRequired" in value) || value["actionRequired"] === undefined)
    return false;
  if (!("pnr" in value) || value["pnr"] === undefined) return false;
  if (!("ticketDocuments" in value) || value["ticketDocuments"] === undefined)
    return false;
  if (!("failure" in value) || value["failure"] === undefined) return false;
  if (!("timeline" in value) || value["timeline"] === undefined) return false;
  if (!("updatedAt" in value) || value["updatedAt"] === undefined) return false;
  return true;
}

export function FlightBookingResponseFromJSON(
  json: any
): FlightBookingResponse {
  return FlightBookingResponseFromJSONTyped(json, false);
}

export function FlightBookingResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingResponse {
  if (json == null) {
    return json;
  }
  return {
    ancillaryStatus:
      json["ancillary_status"] == null ? undefined : json["ancillary_status"],
    loyaltyAttachments:
      json["loyalty_attachments"] == null
        ? undefined
        : (json["loyalty_attachments"] as Array<any>).map(
            FlightLoyaltyAttachmentFromJSON
          ),
    test: json["test"] == null ? undefined : json["test"],
    schemaVersion: json["schema_version"],
    bookingId: json["booking_id"],
    bookingRequestId: json["booking_request_id"],
    status: json["status"],
    paymentStatus: json["payment_status"],
    ticketingDeadline:
      json["ticketing_deadline"] == null
        ? undefined
        : new Date(json["ticketing_deadline"]),
    processingExpiresAt:
      json["processing_expires_at"] == null
        ? undefined
        : new Date(json["processing_expires_at"]),
    ticketingStatus: json["ticketing_status"],
    actionRequired: FlightCheckoutActionFromJSON(json["action_required"]),
    provider: json["provider"] == null ? undefined : json["provider"],
    providerOrderId:
      json["provider_order_id"] == null ? undefined : json["provider_order_id"],
    pnr: json["pnr"],
    airlineLocators:
      json["airline_locators"] == null ? undefined : json["airline_locators"],
    ticketDocuments: json["ticket_documents"],
    itinerary:
      json["itinerary"] == null
        ? undefined
        : FlightObservedItineraryFromJSON(json["itinerary"]),
    fare:
      json["fare"] == null
        ? undefined
        : FlightCheckoutFareFromJSON(json["fare"]),
    price:
      json["price"] == null
        ? undefined
        : FlightCheckoutPriceFromJSON(json["price"]),
    passengers:
      json["passengers"] == null
        ? undefined
        : FlightPassengerCompositionFromJSON(json["passengers"]),
    cancellationStatus:
      json["cancellation_status"] == null
        ? undefined
        : json["cancellation_status"],
    refundStatus:
      json["refund_status"] == null ? undefined : json["refund_status"],
    failure: FlightCheckoutFailureFromJSON(json["failure"]),
    timeline: (json["timeline"] as Array<any>).map(
      FlightCheckoutTimelineEventFromJSON
    ),
    updatedAt: new Date(json["updated_at"]),
  };
}

export function FlightBookingResponseToJSON(json: any): FlightBookingResponse {
  return FlightBookingResponseToJSONTyped(json, false);
}

export function FlightBookingResponseToJSONTyped(
  value?: FlightBookingResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    ancillary_status: value["ancillaryStatus"],
    loyalty_attachments:
      value["loyaltyAttachments"] == null
        ? undefined
        : (value["loyaltyAttachments"] as Array<any>).map(
            FlightLoyaltyAttachmentToJSON
          ),
    test: value["test"],
    schema_version: value["schemaVersion"],
    booking_id: value["bookingId"],
    booking_request_id: value["bookingRequestId"],
    status: value["status"],
    payment_status: value["paymentStatus"],
    ticketing_deadline:
      value["ticketingDeadline"] == null
        ? value["ticketingDeadline"]
        : value["ticketingDeadline"].toISOString(),
    processing_expires_at:
      value["processingExpiresAt"] == null
        ? value["processingExpiresAt"]
        : value["processingExpiresAt"].toISOString(),
    ticketing_status: value["ticketingStatus"],
    action_required: FlightCheckoutActionToJSON(value["actionRequired"]),
    provider: value["provider"],
    provider_order_id: value["providerOrderId"],
    pnr: value["pnr"],
    airline_locators: value["airlineLocators"],
    ticket_documents: value["ticketDocuments"],
    itinerary: FlightObservedItineraryToJSON(value["itinerary"]),
    fare: FlightCheckoutFareToJSON(value["fare"]),
    price: FlightCheckoutPriceToJSON(value["price"]),
    passengers: FlightPassengerCompositionToJSON(value["passengers"]),
    cancellation_status: value["cancellationStatus"],
    refund_status: value["refundStatus"],
    failure: FlightCheckoutFailureToJSON(value["failure"]),
    timeline: (value["timeline"] as Array<any>).map(
      FlightCheckoutTimelineEventToJSON
    ),
    updated_at: value["updatedAt"].toISOString(),
  };
}
